import 'bootstrap-select'

document.addEventListener('turbo:load',  function() {
  $(".selectpicker").selectpicker();
});

document.addEventListener('turbo:render', function() {
  $(".selectpicker").selectpicker();
});
